import { useCallback, useEffect, useState } from "react";

import FileDownloadIcon from "@mui/icons-material/SystemUpdateAlt";
import PrimeButton from "../PrimeButton";
import { getGameCodes } from "../../Utils/Api";
import GamePlatformDialog from "./GamePlatformDialog";

export default function GamePlatformDialogWithButton({ entryTitle, awardId, entry }) {
    const [open, setOpen] = useState(false);
    const [availablePlatforms, setAvailablePlatforms] = useState(null);

    console.log("availablePlatofmrs", availablePlatforms);

    const handlePlatformSelected = useCallback(({ gameCode, platformName }) => {
        const newSelectedPlatform = {
            id: platformName,
            name: platformName,
            available: true,
            code: gameCode,
        };
        const platformsWithUpdatedSelectedPlatform = availablePlatforms
            .map(platform =>
                platform.id === newSelectedPlatform.id
                    ? newSelectedPlatform
                    : {
                        ...platform,
                        available: false,
                    }
            );

        setAvailablePlatforms(platformsWithUpdatedSelectedPlatform);
    }, [availablePlatforms]);

    // Check if we have at least 1 enabled code.
    const hasEnabledCodes = availablePlatforms?.some(p => p.available) ?? false;

    const loading = !availablePlatforms;

    useEffect(() => {
        const gettingPlatformData = async () => {
            const platforms = await getGameCodes(
                awardId,
                entry.id,
            );

            if (platforms.status === "OK" && platforms.platforms) {
                const availablePlatforms = Object.entries(platforms.platforms).map(([platformName, platformAvailibility]) => ({
                    id: platformName,
                    name: platformName,
                    available: platformAvailibility !== "Disabled",
                    code: platformAvailibility !== "Disabled" && platformAvailibility !== "Available" 
                        ? platformAvailibility 
                        : null,
                }));

                setAvailablePlatforms(availablePlatforms);
            }
        }
        gettingPlatformData();
    }, [awardId, entry]);

    function handleOpen() {
        setOpen(true);
    }
    function handleClose() {
        setOpen(false);
    }

    return (
        <>
            {loading
                ? null
                : <>
                    {(hasEnabledCodes || entry.gameBundles || entry.isFreeToPlay)
                        ? <PrimeButton icon={<FileDownloadIcon />} text="Get Game" className="modalLaunchBtn" onClick={handleOpen} style={{ width: "100%" }} />
                        : <PrimeButton icon={<FileDownloadIcon />} text="Not available" className="modalLaunchBtn" disabled style={{ width: "100%" }} />
                    }
                </>
            }
            {open && (
                <GamePlatformDialog
                    awardId={awardId}
                    entry={entry}
                    platformData={availablePlatforms ?? []}
                    hasEnabledCodes={hasEnabledCodes}
                    title={entryTitle}
                    handleClose={handleClose}
                    open={open}
                    onPlatformSelected={handlePlatformSelected}
                />
            )}
        </>
    );
}